exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-landing-page-ghost-jsx": () => import("./../../../src/pages/LandingPageGhost.jsx" /* webpackChunkName: "component---src-pages-landing-page-ghost-jsx" */)
}

